import { render, staticRenderFns } from "./TrackFeedback3.vue?vue&type=template&id=1564ec7f&scoped=true"
import script from "./TrackFeedback3.vue?vue&type=script&lang=js"
export * from "./TrackFeedback3.vue?vue&type=script&lang=js"
import style0 from "./TrackFeedback3.vue?vue&type=style&index=0&id=1564ec7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564ec7f",
  null
  
)

export default component.exports